import { kioskLocation } from "../App/kioskRoutes";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import {
  PinpointProvider,
  KioskConfirmation as DsKioskConfirmation,
} from "@pinpoint/design-system";
import { useAnimationToggle } from "../Contexts/AnimationContext";
import { useDocumentTitle } from "../utils/useDocumentTitle";

/*
 * Full-screen kiosk result after a check-in or checkout. The design system's
 * KioskConfirmation draws the status icon and countdown ring; this wrapper adds
 * the page title, the kiosk animation preference, and the redirect back to the
 * kiosk on tap or after `redirectDelay`.
 */
const KioskConfirmation = ({
  status = "success",
  heading,
  subtitle,
  title,
  redirectTo = "/kiosk",
  redirectDelay = 6000,
}) => {
  const history = useHistory();
  const { animationsEnabled } = useAnimationToggle();
  useDocumentTitle(title);

  const handleContinue = useCallback(() => {
    history.push(kioskLocation(redirectTo, history.location));
  }, [history, redirectTo]);

  return (
    <PinpointProvider animations={animationsEnabled}>
      <DsKioskConfirmation
        status={status}
        heading={heading}
        subtitle={subtitle}
        animationsEnabled={animationsEnabled}
        onContinue={handleContinue}
        continueDelay={redirectDelay}
      />
    </PinpointProvider>
  );
};

export default KioskConfirmation;
